var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kosmo-input',{key:_vm.isBrazilian,attrs:{"label":_vm.labelDocument,"value":_vm.value,"rules":_vm.rulesDocument,"mask":_vm.isBrazilian ? '###.###.###-##' : null,"disabled":_vm.disabled,"placeholder":"Somente números"},on:{"input":value => _vm.$emit('input', value),"blur":_vm.blur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }